export default __webpack_public_path__ + "static/media/blog_image_1.e1c4f1ce.svg";